import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import Reveal from "./Reveal";

const IMG =
  "https://images.pexels.com/photos/17508699/pexels-photo-17508699.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2200";

export default function ContactCTA() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.1, 1]);

  return (
    <section
      ref={ref}
      data-testid="contact-cta"
      className="relative py-32 md:py-40 overflow-hidden bg-[color:var(--bs-ink)] text-white"
    >
      <motion.div style={{ y, scale }} className="absolute inset-0 opacity-60">
        <img
          src={IMG}
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[color:var(--bs-ink)]/70" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <Reveal className="md:col-span-8">
          <div className="overline text-white/60">Contactez-nous</div>
          <h2 className="mt-6 font-display text-5xl md:text-7xl lg:text-8xl font-light tracking-tight leading-[0.95]">
            Prêt à décoller ?<br />
            <span className="italic text-[color:var(--bs-gold)]">Parlons-en.</span>
          </h2>
        </Reveal>
        <Reveal className="md:col-span-4" delay={0.1}>
          <p className="text-white/70 font-light leading-relaxed">
            Un vol, un devis, une simple question ? Nous vous répondons
            sous 24–48 h.
          </p>
          <div className="mt-8 flex flex-col gap-3">
            <Link to="/reservation" data-testid="cta-reserve" className="btn-gold w-fit">
              Réserver un vol <span aria-hidden>→</span>
            </Link>
            <Link
              to="/contact"
              data-testid="cta-contact"
              className="overline link-underline text-white mt-2"
            >
              Nous contacter →
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
